// src/services/api.js
import axios from 'axios';
import { API_URL } from './baseUrl';

// 注册用户的请求函数
export const registerDoctor = async (Data) => {
    try {
        const response = await axios.post(`${API_URL}/register`, Data);
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};


export const loginDoctor = async (Data) => {
    try {
        const response = await axios.post(`${API_URL}/login`, Data);
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};

// export const registerDoctor = (data) => api.post('/register', data);
// export const loginDoctor = (data) => api.post('/login', data);
// export const createReferral = (data) => api.post('/referral', data);
